import productsStepConfig from './ProductsStep';
import reviewStepConfig from './ReviewStep';

const steps = [
  productsStepConfig,
  reviewStepConfig,
];

export default steps;
